<template>
    <div class="file-upload">
        <div v-html="intro">

        </div>
        <div class="attachment-input">
            <div class="title">
                <span v-if="$store.state.form.attachments.length === 1">
                    {{ $store.state.form.attachments.length }}
                    {{ singleFileUploaded }}
                </span>
                <span v-if="$store.state.form.attachments.length > 1">
                    {{ $store.state.form.attachments.length }}
                    {{ multipleFilesUploaded }}
                </span>
            </div>
            <form class="attachments-form" ref="attachmentform">
                <input
                    type="file"
                    name="file"
                    id="file"
                    @change="uploadFile"
                    multiple
                    accept="image/*,video/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                />
                <label for="file">
                    {{ addFilesButton }}
                </label>
            </form>
            <!--<div v-if="image">
                <img :src="image" width="200" height="200" style="max-width:200px;max-height:200px;"/>
                <button class="btn btn-danger" @click="removeImage()">Fjern billede</button>
            </div>-->
        </div>
        <div class="files-wrapper">
            <div class="file-loader" v-show="loading">
                <i class="fal fa-circle-notch fa-spin" />
            </div>
            <div class="file" v-for="(attachment, index) in $store.state.form.attachments" v-bind:key="attachment.path">
                <div class="title">
                    <div class="main">
                        {{ attachment.name }}
                    </div>
                    <div class="size">
                        {{ attachment.size | tomb }}    
                    </div>
                </div>
                <div class="remove" @click="removeAttachment(index)">
                    {{ remove }}
                </div>
            </div>
            <div class="no-files" v-if="$store.state.form.attachments.length === 0">
                {{ noFilesUploaded }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
$color--main: #C80236;

.attachment-input {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title span {
        font-family: 'AvenirHeavyOblique';
    }

    input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    input + label {
        outline: none;
        background: $color--main;
        color: #fff;
        padding: 5px 10px;
        white-space: nowrap;
        transition: 0.3s ease all;
        cursor: pointer;
    }

    input:focus + label,
    input + label:hover {
        background-color: darken($color--main, 10%);
    }
}

.files-wrapper {
    margin-top: 10px;
    background: #eee;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 15px;
    position: relative;
    height: 180px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 15px;

    .file-loader {
        transition: 0.3s ease all;
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 40px;
        color: #fff;
    }

    .file {
        display: flex;
        justify-content: space-between;
        padding: 5px 10px;
        transition: .3s ease all;
        align-items: center;
        transition: 0.3s ease all;

        .title {

            .main {

            }

            .size {
                font-size: 80%;
            }
        }

        .remove {
            color: $color--main;
            cursor: pointer;

            &:hover {
                color: darken($color--main, 10%);
            }
        }
        
        &:not(:last-of-type) {
            border-bottom: 1px dashed rgba(#ccc, 0.5);
        }

        &:hover {
            background: rgba(0, 0, 0, 0.03);
        }
    }

    .no-files {
        transition: 0.3s ease all;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
</style>


<script>
import axios from 'axios'

export default {
    props: [
        'intro',
        'singleFileUploaded',
        'multipleFilesUploaded',
        'noFilesUploaded',
        'addFilesButton',
        'remove'
    ],
    data () {
        return {
            loading: false
        }
    },
    methods: {
        uploadFile (file) {
            // let formData = new FormData()
            let attachments = Object.values(file.target.files)

            attachments.forEach((attachment) => {
                let formData = new FormData()
                /* const acceptedTypes = [
                    'image/jpeg',
                    'image/png',
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ] */
                // if (acceptedTypes.includes(attachment.type)) {
                    let size = (attachment.size / 1000000)
                    if (size < 2000) {
                        this.loading = true
                        formData.append('attachment', attachment)
                        formData.append('casenumber', this.$store.state.form.meta.id)
                        const postUrl = 'https://serviceformapi.qservice.shop/api/upload'
                        axios.post(postUrl, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then((response) => {
                            // SUCCESS
                            let fileObject = {
                                name: attachment.name,
                                size: attachment.size,
                                path: response.data
                            }
                            this.$store.state.form.attachments.push(fileObject)
                            this.$refs.attachmentform.reset()
                            this.loading = false
                        })
                        .catch((response) => {
                            // ERROR
                            console.log(response)
                            this.loading = false
                            alert('File upload failed. Please check if file is damaged.')
                        })
                    } else {
                        alert('File size cannot exceed 2 GB. Please compress the file before uploading or choose a different file.')
                    }
                // } else {
                //    alert('Ugyldigt filformat: ' + attachment.name)
                // }
            })
        },
        removeAttachment (index) {
            this.$store.state.form.attachments.splice(index, 1)
        }
    },
    filters: {
        tomb (number) {
            if (number > 0) {
                let formattedNumber = (number / 1000000).toFixed(2)
                return formattedNumber + ' Mb'
            } else {
                return ''
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// file-upload.vue?453ef768